import { LoadingIcon } from '@/components/UI/LoadingIcon';

function SkeletonMessages() {
  return (
    <div className="flex size-full items-center justify-center">
      <LoadingIcon
        className="size-8 fill-zinc-400/75 text-zinc-400/25 dark:fill-zinc-600/75 dark:text-zinc-600/25"
        isLoading={true}
      />
    </div>
  );
}

export default SkeletonMessages;
